import { useEffect, useRef } from "react";
import { Marker, useMap } from "react-leaflet";

function LgvMarker({ index, lgvMarker, icon, groupOffset, onClick }) {
  const markerRef = useRef(null);
  const map = useMap();

  useEffect(() => {
    return () => {
      // Manual cleanup to avoid duplication
      if (markerRef.current && map) {
        map.removeLayer(markerRef.current);
      }
    };
  }, [index, map]);

  return (
    <Marker
      ref={markerRef}
      type="lgv"
      key={lgvMarker.vehicleNumber}
      data={lgvMarker}
      position={[
        lgvMarker.currentPos.lat + groupOffset.x,
        lgvMarker.currentPos.lng + groupOffset.y,
      ]}
      icon={icon}
      eventHandlers={{
        click: onClick,
      }}
    />
  );
}

export default LgvMarker;
